import { TYPES } from '@components/CRM/Tickets/TicketType';
import { SUBTYPES, TITLES } from '@components/CRM/Tickets/TicketType/constants';

const { UPDATING, TOUR_SELECTION, COMMON_QUESTION, UNKNOWN } = TYPES;

const { NEW, REFUSAL, ORDER, CANCELATION, TOUR, EXTRAS } = SUBTYPES;

export default [
  {
    label: `${TITLES[UNKNOWN]}`,
    subtype: UNKNOWN,
    type: UNKNOWN,
    value: `${UNKNOWN}_1`,
  },
  {
    label: `${TITLES[TOUR_SELECTION]} ${TITLES[REFUSAL]}`,
    subtype: REFUSAL,
    type: TOUR_SELECTION,
    value: `${TOUR_SELECTION}_1`,
  },
  {
    label: `${TITLES[TOUR_SELECTION]} ${TITLES[NEW]}`,
    subtype: NEW,
    type: TOUR_SELECTION,
    value: `${TOUR_SELECTION}_2`,
  },
  {
    label: `${TITLES[UPDATING]} ${TITLES[ORDER]}`,
    subtype: ORDER,
    type: UPDATING,
    value: `${UPDATING}_1`,
  },
  {
    label: `${TITLES[UPDATING]} ${TITLES[CANCELATION]}`,
    subtype: CANCELATION,
    type: UPDATING,
    value: `${UPDATING}_2`,
  },
  {
    label: `${TITLES[COMMON_QUESTION]} ${TITLES[TOUR]}`,
    subtype: TOUR,
    type: COMMON_QUESTION,
    value: `${COMMON_QUESTION}_1`,
  },
  {
    label: `${TITLES[COMMON_QUESTION]} ${TITLES[EXTRAS]}`,
    subtype: EXTRAS,
    type: COMMON_QUESTION,
    value: `${COMMON_QUESTION}_2`,
  },
];
